



































































import { Vue, Component, Prop, Watch, Inject } from "vue-property-decorator";
import ProductPriceDisplay from "@/components/price/ProductPriceDisplay.vue";
import CartItemViewModel from "@/chipply/view-model/CartItemViewModel";
import CartItemInfo from "./CartItemInfo.vue";
import QuantityComponent from "../design-elements/QuantityComponent.vue";
import PriceDisplay from "../price/PriceDisplay.vue";
import IPriceDisplay from "@/chipply/interface/IPriceDisplay";

@Component({
    components: {
        PriceDisplay,
        ProductPriceDisplay,
        CartItemInfo,
        QuantityComponent,
    },
})
export default class CartItem extends Vue {
    public name = "CartItem";

    @Prop({ type: Object })
    public vm!: CartItemViewModel;

    @Prop({ type: Boolean, default: false })
    public isRequestor!: boolean;

    @Prop({ type: Boolean, default: true })
    public allowDelete!: boolean;

    @Inject()
    private priceDisplay!: IPriceDisplay;

    private get mobile() {
        return !this.$vuetify.breakpoint.smAndUp;
    }

    private get imageStyle() {
        return { "background-image": `url(${this.vm.itemImageUrl})` };
    }

    private get contentLayoutClass() {
        return this.mobile ? "" : "row justify-space-between";
    }

    private get showDelete() {
        const self = this as CartItem;
        return self.allowDelete;
    }

    private get showError() {
        return !this.isRequestor && this.vm.errorMessage;
    }

    private get multiPriceDisplay() {
        return this.priceDisplay.displayType == 2;
    }

    private handleOptionChanged(attr: any) {
        this.$emit("optionChanged", attr);
    }

    private handleQtyChange(amount: number) {
        this.$emit("qtyChange", amount);
    }

    private handleManualQtyChange() {
        this.$emit("manualQtyChange");
    }

    private handleValidateManualQty(amount: number) {
        this.$emit("validateQuantity", amount);
    }

    private handleDelete() {
        this.$emit("delete");
    }
}
